var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"header-cta",class:[
    _vm.$route.meta.theme,
    {
      large: _vm.isLarge,
      filled: _vm.isFilled,
    }],on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }